import React, { FC } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import useMakeStripeCheckout from 'buyside/components/presentation/Stripe/useMakeStripeCheckout';

import { PlanInfo, STRIPE_PLANS } from 'interfaces/payment/plans';

import styles from './subscribeCardStyles.scss';

const SubscribeCard: FC<PlanInfo> = ({ name, price, sellingPoints, title, type }) => {
  const stripePlan = STRIPE_PLANS[name];

  const { onSubmit, loading, error } = useMakeStripeCheckout(stripePlan);

  if (error) throw error;

  return (
    <div className={styles.subscribeCard}>
      <div className={styles.subscribeCardTitle}>
        <h4>
          <strong>{title}</strong>
        </h4>
      </div>
      <h2 className={styles.subscribeCardPrice} style={{ marginTop: 0 }}>
        <strong>${price.toLocaleString()}</strong> <span>{type}</span>
      </h2>
      {sellingPoints.map((reason: { [key: string]: string[] }) => {
        const header = Object.keys(reason).toString();

        return (
          <div className={styles.subscribeCardSellingPoints} key={header}>
            <h4>
              <strong>{header}</strong>
            </h4>
            <ul className={styles.subscribeCardSellingPointsList}>
              {reason[header].map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        );
      })}
      <Button
        isLoading={loading}
        onClick={(): void => onSubmit()}
        text={`Choose This${
          [STRIPE_PLANS.retailTier2, STRIPE_PLANS.retailTier3].includes(stripePlan)
            ? ' Package'
            : ' Plan'
        }`}
        type={BUTTON_TYPES.PRIMARY}
      />
    </div>
  );
};

export default SubscribeCard;
